import { render, staticRenderFns } from "./addedit-sub_folder.vue?vue&type=template&id=0dd915f9&scoped=true"
import script from "./addedit-sub_folder.vue?vue&type=script&lang=js"
export * from "./addedit-sub_folder.vue?vue&type=script&lang=js"
import style0 from "./addedit-sub_folder.vue?vue&type=style&index=0&id=0dd915f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd915f9",
  null
  
)

export default component.exports